<template>
  <article class="diary" :data-margin="$route.path === '/tokyo' || $route.path === '/berlin' ? 100 : 0">
    <section class="diary__col diary__col--white">
      <h3 class="diary__title" data-anim="title">{{ colLeft.title }}</h3>
      <p class="diary__subtitle">
        <b data-anim="title" v-html="colLeft.subtitle">
          {{ colLeft.subtitle }}
        </b>
      </p>
      <p
        v-for="text in colLeft.content"
        :key="text"
        v-html="text"
        data-anim="text"
      >
        {{ text }}
      </p>
    </section>

    <section class="diary__col diary__col--black" data-parallax="-0.1">
      <p class="diary__text-italic">
        <span data-anim="title">
          {{ colRight.date }}
        </span>
        <span class="line" data-anim="line"></span>
        <span data-anim="title">
          {{ colRight.year }}
        </span>
      </p>
      <figure>
        <img v-lazy="switchImg" :alt="colRight.alt">
        <div
          v-lazy:background-image="switchImg"
        ></div>
      </figure>
      <p class="figure__text">
        <b data-anim="title" v-html="colRight.caption">
          {{ colRight.caption }}
        </b>
      </p>
      <br>
      <p
        class="figure__content"
        v-for="text in colRight.content"
        :key="text"
        v-html="text"
        data-anim="text"
      >
        {{ text }}
      </p>
    </section>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Diary',

  data() {
    return {
      colLeft: {},
      colRight: {},
    };
  },

  computed: {
    ...mapGetters(['getDataCityComponent']),

    switchImg() {
      if ((window.chrome && window.chrome.webstore) || (window.opr && window.opr.addons)) {
        return `${this.colRight.url}.webp`;
      }
      return `${this.colRight.url}.jpg`;
    },
  },

  created() {
    const data = this.getDataCityComponent(this.$route.params.city, 'diary');

    this.colLeft = data.colLeft;
    this.colRight = data.colRight;
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.diary {
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: wrap;

  padding-bottom: 100px;

  z-index: 1;

  &[data-margin="100"] {
    margin-top: -100px;
  }

  &[data-margin="0"] {
    padding-top: 100px;
  }

  @include mq(sm) {
    align-items: stretch;
    justify-content: flex-start;
    flex-wrap: nowrap;
  }

  b {
    font-weight: 500;
  }

  &__col {
    width: 100%;
    padding: 40px 0;

    @include mq(sm) {
      width: 50%;
    }
  }

  &__col--white {
    padding: 60px 40px;
    color: $color-dark-gray;
    background-color: $color-light;

    @include mq(sm) {
      padding: 100px 100px;
    }

    p {
      padding-bottom: 20px;
    }
  }

  &__col--black {
    padding-top: 40px;

    .figure__text {
      margin-bottom: 20px;
      color: $color-light;

      @include mq(sm) {
        padding-top: 20px;
        margin-bottom: 60px;
      }
    }

    p {
      padding: 0 40px;
      color: $color-gray;

      @include mq(sm) {
        padding: 0 100px;
      }
    }

    .diary__text-italic {
      font-weight: 500;
      font-style: italic;
      color: $color-light;
      padding: 0 40px;

      display: flex;
      align-items: center;

      @include mq(sm) {
        padding: 0 100px;
      }

      span {
        display: inline-block;
      }

      .line {
        position: relative;
        width: 80px;
        height: 1px;
        margin: 0 10px;

        background-color: $color-blue;
      }
    }
  }

  .figure__content {
    padding-bottom: 20px;
  }

  &__title {
    font-size: 2.1875rem;
    color: transparent;
    -webkit-text-stroke: 1.5px $color-dark-gray;
  }

  &__subtitle {
    margin: 60px 0;
  }

  figure {
    position: relative;
    width: 100%;
    margin: 80px 0;
    padding: 0;

    overflow: hidden;

    @include aspect-ratio(4.5, 5);

    @include mq(sm) {
      margin: 80px 0 80px 40px;
    }

    img {
      @include visually-hidden;
    }

    div {
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Diary.vue